// Bundle plugin module

import Plugin from './Plugin';


export default {

  version: () => {
    return NSContext.plugins.search.version;
  }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {
  Plugin.init();
});
